import { GlobalErrorView } from '@client/components/_core/error-handling/GlobalErrorView';
import { useErrorRouteContext } from '@client/components/_core/error-handling/useErrorRouteContext';
import { useAuthStore } from '@client/stores/AuthStore';
import { isAuthRoute } from '@client/utils';
import * as Sentry from '@sentry/react';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { useEffect } from 'react';

export function RouterErrorComponent(props: ErrorComponentProps) {
    const { isPublicSection, orgId } = useErrorRouteContext();

    const { error, reset, info } = props;

    // Capture on error changes only, including errors hidden by the auth suppression below.
    useEffect(() => {
        if (error) {
            Sentry.captureException(error, {
                tags: { location: 'ErrorFallback' },
                level: 'error',
                extra: {
                    orgId,
                    isPublicSection,
                    url: window.location.href,
                    userAgent: navigator.userAgent,
                    info,
                },
            });
        }
    }, [error]);

    // TODO: Remove this once we've migrated from Hasura
    //  Ignore errors on auth routes if the token is expired
    // There should be already a notification displayed
    // After migrating from Hasura, this error fallback is no longer needed
    if (useAuthStore.getState().authTokenExpired && isAuthRoute()) {
        return <div />;
    }

    return <GlobalErrorView isPublicSection={isPublicSection} orgId={orgId} error={error} reset={reset} />;
}
